import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const UsernameActionButton = styled(Button)({
  textTransform: "none",
  padding: 0,
  minWidth: "auto",
});

/** Primary hyperlink-style control for list row actions (Suspend / Resend / Activate). */
export const TableStatusCell = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
});

export const TableRowActionCell = styled(Box)({});

export const TableRowActionLink = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  cursor: "pointer",
  textTransform: "none",
  font: "inherit",
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  color: theme.palette.primary.main,
  textDecoration: "underline",
  "&:hover": {
    color: theme.palette.primary.dark,
  },
  "&:disabled": {
    color: theme.palette.action.disabled,
    cursor: "not-allowed",
    textDecoration: "none",
  },
}));
